
var TeamActions = require("app/screens/Team/actions/team-actions");
var SignalActions = require("app/shared/actions/signal-actions");
var teamsAPI = require("app/util/api/team");
var TeamPrompt = require("app/shared/components/TeamSelector/team-prompt");

var ERROR_MESSAGE_TIME = 5000 

var CreateTeamPrompt = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    onClose: React.PropTypes.func,
    isOpen: React.PropTypes.bool,
    users: React.PropTypes.array,
    onConfirmSuccess: React.PropTypes.func
  },

  getInitialState: function() {
    return {
      isSaving: false,
      buttonText: "Salvar"
    };
  },

  handleConfirm: function(team) {
    this.disableSaveButton();
    TeamActions.addTeam(team, this.handleConfirmSuccess, this.handleConfirmError);
  },

  handleConfirmSuccess: function() {
    if (this.props.onConfirmSuccess) {
      this.props.onConfirmSuccess();
    }

    this.props.onClose();
  },

  handleConfirmError: function(error, response) {
    var errorMessage = teamsAPI.getTeamErrorMessage(error, response);
    SignalActions.show({
      message: errorMessage,
      type: "warning",
      hideTimeout: ERROR_MESSAGE_TIME
    });
    this.enableSaveButton();
  },

  disableSaveButton: function() {
    this.setState({
      isSaving: true,
      buttonText: "Salvando"
    })
  },

  enableSaveButton: function() {
    this.setState({
      isSaving: false,
      buttonText: "Salvar"
    })
  },

  render: function() {
    return <TeamPrompt 
      {...this.props} 
      {...this.state}
      onConfirm={this.handleConfirm} 
      tooltipTitle="Preencha os campos para criar uma equipe." 
      showTooltip={true} 
    />;
  }
});

module.exports = CreateTeamPrompt;



// WEBPACK FOOTER //
// ./app/shared/components/TeamSelector/create-team-prompt.jsx